import React from "react";
import { Typography, List, ListItem, ListItemSecondaryAction, Divider, Link } from "@material-ui/core";
import { IconChevronRight } from "../icons";

const RegionSelector = props => {
  return (
    <div style={{ marginTop: "120px" }}>
      <Typography variant="h6" align="center" style={{ marginBottom: "48px" }}>
        Please choose your region
      </Typography>
      <div style={{ maxWidth: "300px", margin: "0 auto" }}>
        <List>
          <ListItem>
            <Link variant="h6" underline="none" href="au/">
              Australia
            </Link>
            <ListItemSecondaryAction>
              <IconChevronRight style={{ stroke: "#ff6600" }} />
            </ListItemSecondaryAction>
          </ListItem>
          <Divider />
          <ListItem>
            <Link variant="h6" underline="none" href="ca/">
              Canada
            </Link>
            <ListItemSecondaryAction>
              <IconChevronRight style={{ stroke: "#ff6600" }} />
            </ListItemSecondaryAction>
          </ListItem>
          <Divider />
          <ListItem>
            <Link variant="h6" underline="none" href="us/">
              United States
            </Link>
            <ListItemSecondaryAction>
              <IconChevronRight style={{ stroke: "#ff6600" }} />
            </ListItemSecondaryAction>
          </ListItem>
        </List>
      </div>
    </div>
  );
};

export default RegionSelector;
